import React, { useState, useEffect } from "react"
import { graphql } from "gatsby"
import createPersistedState from "use-persisted-state"

import PageLayout from "~layouts/PageLayout"
import Head from "~components/Head"
import Changelog, { Engine, Filters, initialState } from "~components/Changelog"

import "../markdown/_fields"

const ChangelogEntryPage = ({ data, pageContext }) => {
  const [displaySidebar, setDisplaySidebar] = useState(false)
  const usePersistedState = createPersistedState(
    "com.box.developer.changelog.last_shown_at",
  )
  const [lastShownAt, setLastShownAt] = usePersistedState(null)

  const engine = new Engine({
    state: useState(initialState(data.entries.nodes, lastShownAt)),
  })

  useEffect(() => {
    setLastShownAt(new Date())
  }, [])

  return (
    <PageLayout
      alignment="medium"
      displaySidebar={displaySidebar}
      setDisplaySidebar={setDisplaySidebar}
    >
      <Head title={pageContext.title} />
      <Filters engine={engine} />
      <Changelog title={data.changelog.title} engine={engine} />
      <></>
    </PageLayout>
  )
}

export default ChangelogEntryPage

export const query = graphql`
  query($id: String!) {
    changelog: markdownRemark(id: { eq: $id }) {
      ...pageFields
      title
    }
    entries: allMarkdownRemark(
      filter: {
        frontmatter: { type: { eq: "changelog" }, id: { ne: "changelog" } }
      }
      sort: {frontmatter: {published_at: DESC}}
    ) {
      nodes {
        id
        titleAst
        path
        htmlAst
        excerptAst
        frontmatter {
          applies_to
          is_new_feature
          is_impactful
          applied_at
          release_source_url
          collapse
          published_at
          show_excerpt
        }
      }
    }
  }
`
